import cx from 'classnames'

import { type SanityDividerPhotoModule } from '@data/sanity/queries/types/modules'

import Photo from '@components/photo'

type DividerPhotoProps = Pick<SanityDividerPhotoModule, 'photo'> & {
  className?: string
}

const DividerPhoto = ({ photo, className }: DividerPhotoProps) => (
  <Photo
    image={photo}
    className={cx('w-full', className)}
    imageClassName="w-full h-auto"
  />
)

export default DividerPhoto
